import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import EmailCampaignsAPI from '../../api/emailCampaigns';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isSending: false,
  },
};

export const getters = {
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getEmailCampaigns(_state) {
    return _state.records.sort(
      (a, b) => new Date(b.created_at) - new Date(a.created_at)
    );
  },
};

export const actions = {
  get: async ({ commit }) => {
    commit(types.SET_EMAIL_CAMPAIGN_UI_FLAG, { isFetching: true });
    try {
      const response = await EmailCampaignsAPI.get();
      commit(types.SET_EMAIL_CAMPAIGNS, response.data);
    } catch (error) {
      // Ignore
    } finally {
      commit(types.SET_EMAIL_CAMPAIGN_UI_FLAG, { isFetching: false });
    }
  },
  create: async ({ commit }, campaignObj) => {
    commit(types.SET_EMAIL_CAMPAIGN_UI_FLAG, { isCreating: true });
    try {
      const response = await EmailCampaignsAPI.create(campaignObj);
      commit(types.ADD_EMAIL_CAMPAIGN, response.data);
      return response.data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_EMAIL_CAMPAIGN_UI_FLAG, { isCreating: false });
    }
  },
  update: async ({ commit }, { id, ...updateObj }) => {
    try {
      const response = await EmailCampaignsAPI.update(id, updateObj);
      commit(types.EDIT_EMAIL_CAMPAIGN, response.data);
    } catch (error) {
      throw new Error(error);
    }
  },
  delete: async ({ commit }, id) => {
    try {
      await EmailCampaignsAPI.delete(id);
      commit(types.DELETE_EMAIL_CAMPAIGN, id);
    } catch (error) {
      throw new Error(error);
    }
  },
  sendNow: async ({ commit }, id) => {
    commit(types.SET_EMAIL_CAMPAIGN_UI_FLAG, { isSending: true });
    try {
      const response = await EmailCampaignsAPI.sendNow(id);
      return response.data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_EMAIL_CAMPAIGN_UI_FLAG, { isSending: false });
    }
  },
  pause: async (_, id) => {
    try {
      const response = await EmailCampaignsAPI.pause(id);
      return response.data;
    } catch (error) {
      throw new Error(error);
    }
  },
  cancel: async (_, id) => {
    try {
      const response = await EmailCampaignsAPI.cancel(id);
      return response.data;
    } catch (error) {
      throw new Error(error);
    }
  },
};

export const mutations = {
  [types.SET_EMAIL_CAMPAIGN_UI_FLAG](_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },
  [types.ADD_EMAIL_CAMPAIGN]: MutationHelpers.create,
  [types.SET_EMAIL_CAMPAIGNS]: MutationHelpers.set,
  [types.EDIT_EMAIL_CAMPAIGN]: MutationHelpers.update,
  [types.DELETE_EMAIL_CAMPAIGN]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
